import {Types} from "../actions/authenticationActions";
import _ from "lodash";
import ReactPixel from 'react-facebook-pixel';

import cleanDeep from 'clean-deep';


const defaultState = {
  leave: {}
};

const authenticationReducers = (state = defaultState, action) => {
  switch (action.type) {
    
    case Types.AUTHENTICATION_AVAILABLE_ORGANISATIONS: {

      let newState = _.cloneDeep(state);
      newState.my.organisations = action.organisations

      return newState
    }
    case Types.AUTHENTICATION_SHOW_MODAL: {

      let newState = _.cloneDeep(state);
      newState.authentication.showLoginModal = action.status

      return newState
    }
    case Types.AUTHENTICATION_LOGIN: {

      let newState = _.cloneDeep(state);

      if (action.payload.result && action.payload.result.session){
        newState.authentication.invalidLoginCredentials = false;
        // var myDate = new Date();
        // myDate.setMonth(myDate.getMonth() + 1);
        // document.cookie = "PHPSESSID=" + action.payload.result.session + ";expires=" + myDate 
        //                   + ";domain=.buddy.hr;path=/";

        // console.log('sesttingCookie')
      } else if(action.attempt){
        // invalid error
        newState.authentication.invalidLoginCredentials = true;
      }

      if (action.payload.profile){ 
        if(action.attempt) {
          // this was a login attempt not just an API call
          window.gtag('event', 'login', {
            'event_category' : 'engagement',
            'event_label' : 'email'
          });

          ReactPixel.trackCustom('Login');
        }

        const advancedMatching = { 
          em: action.payload.profile.email,
          fn: action.payload.profile.givenName || action.payload.profile.name,
          ln: action.payload.profile.familyName || action.payload.profile.surname,
          external_id: action.payload.profile.id,
        }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
        const options = {
          autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
          debug: false, // enable logs
        };
        ReactPixel.init('310994956063533', advancedMatching, options);

        newState.my.profile = action.payload.profile
        newState.authentication.invalidLoginCredentials = false;

        const userData = localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))

        let updatedProfile = action.payload.profile

        if (userData){
          // keep existing data
          updatedProfile = {
            ...userData,
            ...updatedProfile
          }
        }

        console.log('settingUserData',updatedProfile)
        // set user data used for AC tracking + other forms
        localStorage.setItem('userData',JSON.stringify(updatedProfile))
      }

      if (action.payload.error){
        newState.authentication.error = action.payload.error
      }

      newState.authentication.lockedUntil = action.payload.lockedUntil ? action.payload.lockedUntil : false;

      if (action.payload.lockedUntil) {
        newState.authentication.invalidLoginCredentials = false; // override this so we don't display the error message
      }
      newState.authentication.processing = false;

      return newState;
    }
    case Types.AUTHENTICATION_LOGOUT: {

      let newState = _.cloneDeep(state);
/*
        console.log('sesttingCookie',action.payload)

      if (action.payload.result.session){
        var myDate = new Date();
        myDate.setMonth(myDate.getMonth() + 1);
        document.cookie = "PHPSESSID=" + action.payload.result.session + ";expires=" + myDate 
                          + ";domain=.buddy.hr;path=/";

        console.log('sesttingCookie')
      }*/

      newState.my.profile = false;

      newState.authentication.invalidLoginCredentials = false;
      newState.authentication.error = false;
      newState.authentication.processing = false;

      return newState;
    }
    case Types.AUTHENTICATION_PROCESSING: {

      let newState = _.cloneDeep(state);

      newState.authentication.processing = action.saving;

      return newState;
    }
    case Types.AUTHENTICATION_VALIDATE_CODE: {

      let newState = _.cloneDeep(state);

      newState.authentication.validatingCode = true;

      return newState;
    }
    case Types.AUTHENTICATION_RECOVERY_CODE_CHECK: {

      let newState = _.cloneDeep(state);

      newState.authentication.validatingCode = false;

      if(action.payload.error) {
        newState.authentication.recoveryCodeError = action.payload.error;
      } else {
        newState.authentication.recoveryCodeError = false;
      }

      if(action.payload.profile) { 
        newState.my.profile = action.payload.profile
      }

      return newState;
    }
    case Types.AUTHENTICATION_SETTING_PASSWORD: {

      let newState = _.cloneDeep(state);

      newState.authentication.settingPassword = true;

      return newState;
    }
    case Types.AUTHENTICATION_SET_PASSWORD_RESULT: {

      let newState = _.cloneDeep(state);

      newState.authentication.settingPassword = false;

      if(action.payload.error) {
        newState.authentication.recoveryCodeError = action.payload.error;
      } else {
        newState.authentication.recoveryCodeError = false;
      }

      if(action.payload.profile) { 
        newState.my.profile = action.payload.profile
      }

      return newState;
    }
    case Types.AUTHENTICATION_SET_MFA_EXPIRY: {
      let newState = _.cloneDeep(state);
      newState.my.profile.mfaExpires = action.expiry;
      return newState;
    }
    case Types.AUTHENTICATION_SET_MFA_EXPIRY: {
      let newState = _.cloneDeep(state);
      newState.my.profile.mfaExpires = action.expiry;
      return newState;
    }
    case Types.AUTHENTICATION_SET_MFA: {
      let newState = _.cloneDeep(state);
      newState.my.mfa ={
        ...newState.my.mfa,
        setup: action.payload
      };
      return newState;
    }
    case Types.AUTHENTICATION_MFA_VERIFIED: {
      let newState = _.cloneDeep(state);
      newState.my.mfa.verified = action.status;
      newState.my.profile.hasMFA = action.status;
      return newState;
    }
    case Types.AUTHENTICATION_MFA_MODAL_STATUS: {
      let newState = _.cloneDeep(state);
      newState.my.mfa.isModalOpen = action.status;
      return newState;
    }
    default:
      return state;
  }
};

export default authenticationReducers;